import React from "react";
import Row from "../components/Row";
import SavedSeries from "../components/SavedSeries";
import { useSavedSeries } from "../context/SavedSeriesContext";
import { useContent } from "../context/ContentContext";
import Main from "../components/Main";

const RowSkeleton = () => (
  <div className="px-4 mb-6">
    <div className="h-6 w-40 bg-gray-700 rounded animate-pulse mb-3" />
    <div className="flex gap-3 overflow-hidden">
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className="w-[160px] sm:w-[200px] md:w-[240px] flex-shrink-0"
        >
          <div className="aspect-video rounded bg-gray-700 animate-pulse" />
          <div className="h-3 mt-2 w-3/4 mx-auto bg-gray-700 rounded animate-pulse" />
        </div>
      ))}
    </div>
  </div>
);

const Home = () => {
  const { savedSeries } = useSavedSeries();
  const { categories, liveEpisodes = [], loading } = useContent();
  const liveCount = liveEpisodes.length;

  return (
    <div>
      <Main />

      {liveCount > 0 && (
        <div className="mx-4 mt-4 flex items-center gap-3 rounded-lg bg-black/60 border border-green-500/40 px-4 py-3">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
          </span>
          <span className="text-white font-semibold text-sm md:text-base">
            {liveCount} channel{liveCount !== 1 ? "s" : ""} live now
          </span>
        </div>
      )}

      <div id="categories" className="mx-auto text-center py-8">
        <h1 className="text-white text-xl md:text-3xl font-bold">
          Select a thumbnail below to watch digital broadcasts
        </h1>
      </div>

      {savedSeries?.length > 0 && (
        <SavedSeries liveEpisodes={liveEpisodes} savedSeries={savedSeries} />
      )}

      {loading
        ? Array.from({ length: 3 }).map((_, i) => <RowSkeleton key={i} />)
        : categories?.map((category) => (
            <Row
              key={category.query}
              category={category}
              liveEpisodes={liveEpisodes}
            />
          ))}
    </div>
  );
};

export default Home;
